import { render, staticRenderFns } from "./SalaAulaApp.vue?vue&type=template&id=63fb5e9e&scoped=true&"
import script from "./SalaAulaApp.vue?vue&type=script&lang=js&"
export * from "./SalaAulaApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fb5e9e",
  null
  
)

export default component.exports